import { BasePagedSearchCriteria } from "./BaseSearchCriteria";

export interface ParkingAreaSearchCriteria extends BasePagedSearchCriteria{
    name?:string;
}

 
export const PARKING_AREA_SEARCH_CRITERIA_KEY = 'ParkingAreaSearchCriteria';